import FullScreenLoader from "../../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useDispatch, useSelector } from "react-redux";
import { useProperty } from "../../../PropertyContext";
import ReservationHeader from "../../Commun/ReservationHeader"
import ReservationSidebar from "../../Commun/ReservationSidebar"
import { deleteTerms, fetchTerms } from "../../../Redux/Slices/termsSlice";
import { useEffect, useState } from "react";
import { AddTermsAndCon } from "./AddTermsAndCon";
import swal from "sweetalert";
import { EditTermsAndCondition } from "./EditTermsAndCondition";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export const TermsAndCondision = () => {
    const { selectedProperty } = useProperty();
    const dispatch = useDispatch();

    const [selectedTerm, setSelectedTerm] = useState(null);

    const { termsList, loading } = useSelector((state) => state.terms);

    useEffect(() => {

        dispatch(fetchTerms(selectedProperty.PropertyID));

    }, [dispatch, selectedProperty]);


    const handleDelete = async (id) => {

        const willDelete = await swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        });

        if (willDelete) {
            try {
                const resultAction = await dispatch(deleteTerms(id));

                if (deleteTerms.fulfilled.match(resultAction)) {
                    swal("Deleted!", "Record deleted successfully", "success");

                    // ❌ fetchTerms ki zarurat nahi
                    // UI already update ho chuka hai
                } else {
                    swal("Error!", "Something went wrong!", "error");
                }

            } catch (error) {
                swal("Error!", "Failed to delete!", "error");
            }
        }
    };

    return (
        <>
            {loading && (
                <FullScreenLoader />
            )}
            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h4 className="card-title">TERMS AND CONDITIONS</h4>
                                                <button type="button" className="btn btn-primary btn-sm waves-effect waves-light mt-1" data-bs-toggle="modal" data-bs-target="#Add-Terms-Condition">Add </button>
                                            </div>
                                        </div>
                                        {/* <div className="card-body">
                                            <div className="table-responsive">

                                                <table className="display table table-striped table-hover basic-datatables">
                                                    <thead>
                                                        <tr>
                                                            <th>Description</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {termsList && termsList.length > 0 ? (
                                                            termsList.map((item) => (
                                                                <tr key={item.ID}>
                                                                    <td>{item.Description}</td>
                                                                    <td>
                                                                        <button className="btn" data-bs-toggle="modal" data-bs-target="#Edit-Terms-Condition" onClick={() => setSelectedTerm(item)}><i className="fas fa-edit"></i></button>
                                                                        <button className="btn text-danger" onClick={() => handleDelete(item.ID)}> <i className="fas fa-trash"></i> </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="2" className="text-center">
                                                                    No Data Found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> */}

                                        <div className="card-body">
                                            <DataTable
                                                value={termsList}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[5, 10, 25]}
                                                stripedRows
                                                showGridlines
                                                responsiveLayout="scroll"
                                                emptyMessage="No Data Found"
                                                filterDisplay="menu"
                                            >

                                                {/* Description Column */}
                                                <Column
                                                    field="Description"
                                                    header="Description"
                                                    sortable
                                                    filter
                                                    filterPlaceholder="Search Description"
                                                />

                                                {/* Action Column */}
                                                <Column                                                 
                                                    header="Action"
                                                    headerClassName="action-header-center"
                                                    body={(rowData) => (
                                                        <div className="d-flex gap-2">

                                                            <button
                                                                className="btn"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#Edit-Terms-Condition"
                                                                onClick={() => setSelectedTerm(rowData)}
                                                            >
                                                                <i className="fas fa-edit"></i>
                                                            </button>

                                                            <button
                                                                className="btn text-danger"
                                                                onClick={() => handleDelete(rowData.ID)}
                                                            >
                                                                <i className="fas fa-trash"></i>
                                                            </button>

                                                        </div>
                                                    )}
                                                    style={{ width: "8rem" }}
                                                />

                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* Terms And Condition modal content */}
            <div id="Add-Terms-Condition" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Terms And Condition</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <AddTermsAndCon termsList={termsList} />
                        </div>
                    </div>
                </div>
            </div>
            {/* /.modal */}

            {/*Edit Terms And Condition modal content */}
            <div id="Edit-Terms-Condition" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Terms And Condition</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body">
                            <EditTermsAndCondition termData={selectedTerm} />
                        </div>
                    </div>
                </div>
            </div>
            {/* /.modal */}
        </>
    )
}
